module.exports = __webpack_public_path__ + "static/media/commerical-6.95f675c1.jpg";